import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import Logo from "../assets/logo.png";

const MenuButton = styled.button`
  display: none;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 1000;

  @media (max-width: 992px) {
    display: block;
    position: absolute;
    right: 20px;
    top: 20px;
  }

  span {
    display: block;
    width: 30px;
    height: 4px;
    margin: 6px 0;
    position: relative;
    background: white;
    border-radius: 3px;
    z-index: 1;
    transform-origin: 50% 50%;
    transition: all 0.4s cubic-bezier(0.23, 1, 0.32, 1);
  }

  &.open span {
    background: white;
  }

  &.open span:first-child {
    transform: rotate(45deg) translate(12px, 8px);
  }

  &.open span:nth-child(2) {
    opacity: 0;
    transform: scale(0);
  }

  &.open span:last-child {
    transform: rotate(-45deg) translate(12px, -8px);
  }

  &.open span:nth-child(2) {
    opacity: 0;
    transform: scale(0);
  }
`;

const NavMenu = styled.nav`
  position: fixed;
  top: 0;
  right: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, var(--primary-color) 0%, #273849 100%);
  transition: right 0.4s cubic-bezier(0.77, 0.2, 0.05, 1);
  box-shadow: -4px 0 15px #00000033;
  overflow-y: auto;
  padding-top: 100px;
  z-index: 999;

  &.open {
    right: 0;
  }

  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }

  li {
    margin: 0 15px;
    border-bottom: 1px solid #ffffff1a;
  }

  a {
    color: white;
    text-decoration: none;
    display: block;
    padding: 15px;
    font-weight: 500;
    position: relative;
    overflow: hidden;

    &:after {
      content: "";
      position: absolute;
      bottom: 0;
      left: -100%;
      width: 100%;
      height: 2px;
      background-color: var(--secondary-color);
      transition: left 0.3s ease;
    }

    &:hover:after {
      left: 0;
    }
  }

  .mobile-language-switcher {
    margin: 20px 20px;
    display: flex;
    align-items: center;
    gap: 10px;
    color: white;
    font-size: 14px;
    font-weight: 500;
    
    .language-label {
      opacity: 0.8;
      transition: opacity 0.3s ease;
    }

    &:hover .language-label {
      opacity: 1;
    }

    .language-select {
      background: rgba(255, 255, 255, 0.1);
      border: 1px solid rgba(255, 255, 255, 0.2);
      color: white;
      padding: 8px 12px;
      border-radius: 8px;
      cursor: pointer;
      width: 100px;
      font-weight: 500;
      font-size: 14px;
      transition: all 0.3s ease;
      
      &:hover {
        background: rgba(255, 255, 255, 0.2);
        border-color: rgba(255, 255, 255, 0.3);
      }

      option {
        background: white;
        color: black;
        padding: 8px;
        font-weight: 500;
        font-size: 14px;
      }

      option:checked {
        background: var(--primary-color);
        color: white;
      }
    }
  }
`;

const MobileMenu = ({ links }) => {
  const { t, i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    toggleMenu(); // Close menu after language change
  };

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 992);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
    document.body.classList.toggle('menu-open', !isOpen);
  };

  if (!isMobile) return null;

  return (
    <>
      <MenuButton className={isOpen ? "open" : ""} onClick={toggleMenu}>
        <span></span>
        <span></span>
        <span></span>
      </MenuButton>

      <NavMenu className={isOpen ? "open" : ""}>
        <div className="menu-header">
          <div className="mobile-logo">
            <img src={Logo} alt={t("common.logo")} className="navbar-logo" />
          </div>
        </div>
        <ul>
          {links.map((link, index) => (
            <li key={index}>
              <a href={link.href} onClick={toggleMenu}>{link.text}</a>
            </li>
          ))}
        </ul>
        <div className="mobile-language-switcher">
          <span className="language-label">{t('common.language')}</span>
          <select className="language-select" onChange={(e) => changeLanguage(e.target.value)}>
            <option value="en">EN</option>
            <option value="ru">RU</option>
            <option value="ka">KA</option>
          </select>
        </div>
      </NavMenu>
    </>
  );
};

export default MobileMenu;
